
import { Link } from 'react-router-dom';
import React, { Component } from 'react'; 

class Simon extends Component{ 
    componentDidMount(){
    window.startx();
  }
    render(){ 
        return (
          <div id="main" className="wrapper style1">
            <div className="container">
              <header className="major">
                <h2>Simon Dice</h2>
              </header>
          <span className="containerjuego">
            <div className="content">
              <div>
              <h2>

              </h2>
              </div>
                <iframe align="center" frameborder="0" allowtransparency="true" src="https://spritted.com/en/game/simon-memorize?embed" width="1080px" height="720px" title='Simon'></iframe>
              <h5>
              </h5>
          </div>
            <div>
<div className="containerjuego">
              <Link className="button" to="/juego">
                Regresar
              </Link>
            </div>
            </div>
            </span>
            </div>
          </div>

          );
    } 
} 

export default Simon;